import React, { useMemo, useState } from 'react';
import { ListGroup } from 'react-bootstrap-5';
import { connect } from 'react-redux';

import Task from '../call_list/tasks/task';
import EditTaskModal from '../call_list/tasks/edit_task_modal';
import NewTaskModal from '../call_list/tasks/new_task_modal';
import { createPortal } from 'react-dom';
import { Button } from 'components/ui/button';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { addActivity, removeActivity, updateActivity } from 'bundles/connect/components/store/actions/activities';
import type { Activity } from 'bundles/connect/types';

type Props = {
  activities: Activity[];
  addActivity: (activity: Activity) => { type: string; payload: Activity };
  removeActivity: (id: number, type?: string) => ((dispatch: any) => Promise<void>);
  updateActivity: (activity: Activity) => Promise<void>;
}

function TaskList({ activities, addActivity, removeActivity, updateActivity }: Props) {
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
  const [taskForEdit, setTaskForEdit] = useState<Activity | null>(null);
  const createButtonElement = useMemo(() => document.getElementById('js-new-task-button'), []);

  return (
    <>
      {activities.length > 0 && (
        <ListGroup variant="flush">
          {activities.map(task => (
            <Task
              key={task.id}
              task={task}
              onDelete={() => removeActivity(task.id, 'Task')}
              onEdit={setTaskForEdit}
              onUpdate={updateActivity}
            />
          ))}
        </ListGroup>
      )}
      {activities.length === 0 && (
        <div className="p-4 text-center">
          <div className="my-4">
            <span className="fa-stack fa-xl">
              <i className="fa-solid fa-stack-2x fa-circle icon-gradient" />
              <i className="fa-solid fa-stack-1x fa-inverse fa-calendar" />
            </span>
          </div>
          <h6 className="mb-4 fw-bold">No tasks were found</h6>
        </div>
      )}
      <EditTaskModal
        existingActivity={taskForEdit}
        onHide={() => setTaskForEdit(null)}
        onUpdate={updateActivity}
      />
      <NewTaskModal
        initialConnectedRecords={[]}
        show={showNewTaskModal}
        onAdd={addActivity}
        onHide={() => setShowNewTaskModal(false)}
      />
      { createButtonElement && createPortal((
        <Button icon={faPlus} label="New Task" onClick={() => setShowNewTaskModal(true)} />
      ), createButtonElement)}
    </>
  );
}

const mapStateToProps = ({ activities }) => ({ activities });
export default connect(mapStateToProps, { addActivity, removeActivity, updateActivity })(TaskList);

